import { IsString, IsNumber, IsIn, IsBoolean, IsOptional, IsDefined, Min } from 'class-validator';

const INPUT_TYPE_VALUES = ['text'] as const;

export class FormTextFieldPropsDto {
  @IsOptional()
  @IsString()
  id?: string;

  @IsDefined()
  @IsIn([...INPUT_TYPE_VALUES])
  inputType!: string;

  @IsDefined()
  @IsString()
  label!: string;

  @IsDefined()
  @IsBoolean()
  showLabel!: boolean;

  @IsDefined()
  @IsString()
  placeholder!: string;

  @IsDefined()
  @IsBoolean()
  required!: boolean;

  @IsDefined()
  @IsBoolean()
  hidden!: boolean;

  @IsDefined()
  @IsString()
  helpText!: string;

  @IsDefined()
  @IsBoolean()
  showHelpText!: boolean;

  @IsDefined()
  @IsBoolean()
  enforceCharacterLimit!: boolean;

  @IsOptional()
  @IsNumber()
  @Min(0)
  minCharacterLimit?: number | null;

  @IsOptional()
  @IsNumber()
  @Min(0)
  maxCharacterLimit?: number | null;

  @IsOptional()
  @IsString()
  urlMapping?: string;
}
